import {
  App,
  CountryCluster,
  Partner,
  User,
  PasswordError,
  UserError,
} from '@/interfaces';
import { AdminState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  setUsers(state: AdminState, payload: User[]) {
    state.users = payload;
  },
  setUser(state: AdminState, payload: User) {
    const users = state.users.filter((user: User) => user.id !== payload.id);
    users.push(payload);
    state.users = users;
    state.userResult = payload.id;
  },
  clearUserResult(state: AdminState) {
    state.userResult = 0;
  },
  setUserError(state: AdminState, payload: UserError) {
    state.userError = payload;
  },
  clearUserError(state: AdminState) {
    state.userError = null;
  },
  setUserPasswordError(state: AdminState, payload: PasswordError) {
    state.userPasswordError = payload;
  },
  clearUserPasswordError(state: AdminState) {
    state.userPasswordError = null;
  },
  setApps(state: AdminState, payload: App[]) {
    state.apps = payload;
  },
  setApp(state: AdminState, payload: App) {
    const apps = state.apps.filter((app: App) => app.id !== payload.id);
    apps.push(payload);
    state.apps = apps;
  },
  setLastId(state: AdminState, payload: number) {
    state.lastId = payload;
  },
  setSelectedUsers(state: AdminState, payload: User[]) {
    state.selectedUsers = payload;
  },
  setSelectedApps(state: AdminState, payload: App[]) {
    state.selectedApps = payload;
  },
  setCountryClusters(state: AdminState, payload: CountryCluster[]) {
    state.countryClusters = payload;
  },
  removeCountryCluster(state: AdminState, payload: CountryCluster) {
    const countryClusters = state.countryClusters.filter(
      (cluster: CountryCluster) => cluster.id !== payload.id,
    );
    state.countryClusters = countryClusters;
  },
  setPartners(state: AdminState, payload: Partner[]) {
    state.partners = payload;
  },
  setPartner(state: AdminState, payload: Partner) {
    const partners = state.partners.filter(
      (partner: Partner) => partner.id !== payload.id,
    );
    partners.push(payload);
    state.partners = partners;
  },
  setPartnersByApp(state: AdminState, payload: Partner[]) {
    state.partnersByApp = payload;
  },
  setAppsByPartner(state: AdminState, payload: App[]) {
    state.appsByPartner = payload;
  },
};

const { commit } = getStoreAccessors<AdminState, State>('');

export const commitSetUser = commit(mutations.setUser);
export const commitSetUsers = commit(mutations.setUsers);
export const commitClearUserResult = commit(mutations.clearUserResult);
export const commitSetUserError = commit(mutations.setUserError);
export const commitClearUserError = commit(mutations.clearUserError);
export const commitSetUserPasswordError = commit(
  mutations.setUserPasswordError,
);
export const commitClearUserPasswordError = commit(
  mutations.clearUserPasswordError,
);
export const commitSetApps = commit(mutations.setApps);
export const commitSetApp = commit(mutations.setApp);
export const commitSetLastId = commit(mutations.setLastId);
export const commitSetSelectedUsers = commit(mutations.setSelectedUsers);
export const commitSetSelectedApps = commit(mutations.setSelectedApps);
export const commitSetCountryClusters = commit(mutations.setCountryClusters);
export const commitRemoveCountryCluster = commit(
  mutations.removeCountryCluster,
);
export const commitSetPartners = commit(mutations.setPartners);
export const commitSetPartner = commit(mutations.setPartner);
export const commitSetPartnersByApp = commit(mutations.setPartnersByApp);
export const commitSetAppsByPartner = commit(mutations.setAppsByPartner);
